  <div class="LiveAPINotfiicationContainer" *ngIf="LocalEnviormentWithLiveAPIWarning == true;">
    {{'LocalEnviormentWithLiveAPIWarning' | translate}}
  </div>

  <div class="overlay dashOverlay" *ngIf="ShowMainMenu == true || ShowCart == true;" (click)="CloseDashMenu();"></div>
  <div class="overlay animated fadeIn" *ngIf="ShowItemStockOptions || ClearGridQuestion || ShowAppsSelect || showLoggOffContainer || loading || ShowDeleteBoxQuestion;"></div>
  <div class="overlay" *ngIf="showContent != true;"></div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ClearGridQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ClearGridQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'ClearGridQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.loading" mat-raised-button class="InfoQuestionButton" (click)="ClearGridQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.loading" mat-raised-button color="warn" class="InfoQuestionButton PrimaryButtonTheme" (click)="ClearGridQuestion = false;ClearGrid();">
        <i class="material-icons">close</i>
        {{ 'ClearGrid' | translate }}
      </button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="showLoggOffContainer">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="showLoggOffContainer = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'LogOffQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'LogOffQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.loading" mat-raised-button class="InfoQuestionButton" (click)="showLoggOffContainer = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.loading" mat-raised-button color="primary" class="InfoQuestionButton PrimaryButtonTheme" (click)="showLoggOffContainer = false;LogOff();">
        <i class="material-icons">logout</i>
        {{ 'Dashboard.Menu.LogOff' | translate }}
      </button>
    </div>
  </div>
  
  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteBoxQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteBoxQuestion = false; CartItem = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.loading" mat-raised-button color="warn" class="InfoQuestionButton PrimaryButtonTheme" (click)="ShowDeleteBoxQuestion = false;this.DeleteCartItem();">
        <i class="material-icons">close</i>
        {{ 'Configuration.DeleteYesButton' | translate }}
      </button>
    </div>
  </div>

  <div class="NotificationCenter animated fadeInDown" *ngIf="ShowAppsSelect" style="height: auto; width: 30vw; left: 35%;">
    <div class="NotificationCenterTitle">
      {{'SelectApplication' | translate}}
    </div>
    <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowAppsSelect = false;">close</i>
      </div>
      <div class="InfoQuestionBody" style="padding-right: 5%;">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'SelectApplication' | translate }}</mat-label>
            <mat-select name="SelectApplication" [(ngModel)]="AuxCurrentApp" [compareWith]="compareFn">
              <mat-option *ngFor="let app of this.Applications;" [value]="app">
                {{app.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </div>
  
      <div class="InfoQuestionCommands" style="padding-bottom: 20px;height: auto;">
        <button mat-raised-button color="primary" class="AppChangeButton" (click)="SwitchApplication();">
            <i class="material-icons">check</i>
            {{'SelectApplication' | translate}}
        </button>
      </div>
  </div>

  <div *ngIf="this.ShowItemStockOptions == true;" class="ItemStockOptionsContainer animated fadeInDown">
    <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.SideOffersLoading == true;" style="margin-top: 50px;"></mat-spinner>
    <div *ngIf="this.SideOffersLoading != true;">
      <div class="ItemStockOptionsContainerTitle">
        <p>{{this.CurrentGridItem?.Product?.Brand?.Name}} {{this.CurrentGridItem?.UIProductValue}}</p>
      </div>
      <div class="ItemStockOptionsContainerCloseIcon">
          <i class="material-icons" (click)="this.ShowItemStockOptions = false;">close</i>
      </div>
      <div class="ItemStockOptionsContainerBody">
          <div class="CurrentGridItemOffer" style="background: #f60; color: #fff;">
            <span class="CurrentGridItemOfferDotSPan"></span>
            <span class="CurrentGridItemOfferNameSpan"># {{'Offers' | translate}}</span>
            <span class="CurrentGridItemOfferMOQSpan">MOQ</span>
            <span class="CurrentGridItemOfferInfoSpan">{{'Price' | translate}}</span>
            <span class="CurrentGridItemOfferInfoSpan">{{'ETA' | translate}}</span>
          </div>

          <div class="CurrentGridItemOffer" *ngFor="let offer of this.CurrentGridItem.Product.ListPriceOffers; let i = index;" (click)="SelectOfferFromGrid(offer, this.CurrentGridItem);">
            <span class="CurrentGridItemOfferDotSPan">
              <div class="OfferDot" *ngIf="offer.IsSelected == true;"></div>
            </span>
            <span class="CurrentGridItemOfferNameSpan">{{i + 1}} - {{this.CurrentGridItem?.Product?.Brand?.Name}} {{this.CurrentGridItem?.UIProductValue}}</span>
            <span class="CurrentGridItemOfferMOQSpan">{{offer.MOQ}}</span>
            <span class="CurrentGridItemOfferInfoSpan">{{offer.SellPrice?.UIUnitPrice}} {{offer.Currency?.Name}}</span>
            <span class="CurrentGridItemOfferInfoSpan">{{offer.LeadTime?.Units}} {{offer.LeadTime?.Type?.Name}}</span>
          </div>
      </div>
    </div>
  </div>
  
  <div class="loginBodyContainer" style="background: #f9f9f9;overflow-y: auto;">
      <!-- <div class="UpperBanner">
        <div class="UpperBannerInfoBox" (click)="this.RedirectToURLWithUrlChange('B2B/search');">
          <img *ngIf="this.Company?.LogoPath?.length > 0;" [src]="this.BackendServiceUrl + this.Company?.LogoPath" />
        </div>

        <div class="UpperBannerInfoBox">
          <p>{{'ContactYourAgent' | translate}}: </p>
        </div>

        <div class="UpperBannerInfoBox">
          <i class="material-icons">account_circle</i>
          <p>{{this.B2BAgent?.Name}}</p>
        </div>

        <div class="UpperBannerInfoBox">
          <i class="material-icons">phone</i>
          <p><a href="tel:{{this.B2BAgent?.Phone}}" style="color: #000;">{{this.B2BAgent?.Phone}}</a></p>
        </div>

        <div class="UpperBannerInfoBox MainWhatsappButton">
          <i class="fa fa-whatsapp" style="font-size:24px;color: #fff;height: 30px; line-height: 30px;"></i>
          <p style="height: 30px; line-height: 30px;"><a href="tel:{{this.B2BAgent?.Phone}}" style="color: #fff;">{{this.B2BAgent?.Phone}}</a></p>
        </div>

        <div class="UpperBannerInfoBox" style="text-transform: lowercase;">
          <i class="material-icons">email</i>
          <p><a href="mailto:{{this.B2BAgent?.Email}}" style="color: #000;">{{this.B2BAgent?.Email}}</a></p>
        </div>
      </div> -->
      
      <div class="UpperMenu">
        <mat-progress-bar mode="query" class="MainProgressBar" *ngIf="this.loading == true;"></mat-progress-bar>
        <div class="UpperMenuIconContainer">
            <i class="material-icons" *ngIf="this.ShowAdminInformation == true;" (click)="RedirectToURLWithUrlChangeNewTab('management/offer/requests');">menu</i>
        </div>
        <div class="UpperMenuContent">

          
          <div class="UpperMenuContentAppTitle unSelectable">
            <p (click)="OpenAppsSelect();">
              <!-- <span>{{this.Company?.Alias}}</span> -->
              <!-- <i class="material-icons">cloud_queue</i> -->
              <!-- <span>{{this.CurrentApp?.Name}}</span> -->
              <img class="b2bCompanyLogo" *ngIf="this.Company?.LogoPath?.length > 0;" [src]="this.BackendServiceUrl + this.Company?.LogoPath" />
            </p>
          </div>

          <!-- <div class="UpperMenuContentUserContainer">
            <button mat-button class="UserDropDownButton" (click)="OpenCart();">
              <p [ngClass]="{'selectedMenu': this.CartMenu == true}">
                <span style="float: left;" [ngClass]="{'selectedMenuFont': this.CartMenu == true}">{{'Cart' | translate}}</span>
                <i style="float: left;" class="material-icons">shopping_cart</i>
              </p>
              <span class="CartCount" *ngIf="this.Cart?.Items?.length > 0;">{{this.Cart?.CountableItems}}</span>
            </button>

            <div class="CartContainer animated fadeIn" *ngIf="this.ShowCart">
              <div class="Triangle"></div>
              <div class="CartTitle">{{'CartTitle' | translate}}</div>
              <div class="CartBody">
                <div *ngFor="let item of this.Cart?.Items;">
                 <div class="CartProductRow" *ngIf="item?.UIProductValue?.length > 0;">
                  <p class="CartItemRowP">
                    {{item?.Product?.Brand?.Name}} {{item?.Product?.Name}}
                    <span *ngIf="item.Product.PartNumber?.length > 0 && item.Product.PartNumber != item.Product.Name;">({{item.Product.PartNumber}})</span>
                    <span>x {{item.Quantity}}</span>
                  </p>
                  <p class="TypeOffer" *ngIf="item.SelectedOffer != null && item.Price?.UIUnitPrice != null;">{{item.Price.UIUnitPrice}} {{item.SelectedOffer?.Currency?.Name}} ({{'ExcludingVAT' | translate}}) - {{item.Price.VAT.Percentage}}% {{'VATRate' | translate}}</p>
                 </div>
                </div>
              </div>

              <div class="CartCommands">
                <p class="CartTotalRow" style="color: #4d148c;font-weight: 700;" *ngIf="this.Cart?.Items?.length > 0;">{{'TotalProducts' | translate}}: {{this.Cart?.CountableItems}}</p>
              </div>

              <div class="CartCommands">
                <button class="ViewCartButton" mat-raised-button color="primary" (click)="RedirectToURLWithUrlChange('B2B/store/cart');">
                  <i class="material-icons">shopping_cart_checkout</i>
                  <span>{{ 'ViewCart' | translate }}</span>
                </button>
              </div>
            </div>
          </div> -->

          <div class="UpperMenuContentUserContainer">
            <button mat-button [matMenuTriggerFor]="afterMenu2" class="UserDropDownButton">
              <p [ngClass]="{'selectedMenu': this.MyProfileMenu == true}">
                <span style="float: left;" [ngClass]="{'selectedMenuFont': this.MyProfileMenu == true}">{{'MyProfile' | translate}}</span>
                <i style="float: left;" class="material-icons">account_circle</i>
              </p>
              
            </button>
              <mat-menu #afterMenu2="matMenu" xPosition="after">
                <button mat-menu-item class="UserMenuButton" (click)="RedirectToURLWithUrlChange('/B2B/profile');">
                  <i class="material-icons" style="line-height: 48px; margin-right: 10px;">account_circle</i>
                  <span style="float: right;">{{ 'MyProfile' | translate}}</span>
                </button>
                <button mat-menu-item class="UserMenuButton" (click)="showLoggOffContainer = true;">
                  <i class="material-icons" style="line-height: 48px; margin-right: 10px;">logout</i>
                  <span style="float: right;">{{ 'LogOff' | translate}}</span>
                </button>
              </mat-menu>
          </div>
        
          <div class="UpperMenuContentUserContainer">
            <p [ngClass]="{'selectedMenu': this.OrdersMenu == true}" (click)="RedirectToURLWithUrlChange('/B2B/my/orders');">{{'Orders' | translate}}</p>
          </div>
          <div class="UpperMenuContentUserContainer">
            <p [ngClass]="{'selectedMenu': this.InvoiceMenu == true}" (click)="RedirectToURLWithUrlChange('/B2B/my/invoices');">{{'Invoices' | translate}}</p>
          </div>

          <div class="UpperMenuContentUserContainer">
            <p [ngClass]="{'selectedMenu': this.SavedOffersPOsMenu == true}" (click)="RedirectToURLWithUrlChange('/B2B/my/requests');">{{'SavedOffersPOs' | translate}}</p>
          </div>

          <div class="UpperMenuContentUserContainer">
            <p [ngClass]="{'selectedMenu': this.PriceListMenu == true}" (click)="RedirectToURLWithUrlChange('/B2B/search');">{{'PriceList' | translate}}</p>
          </div>
          <!-- <div class="UpperMenuContentUserContainer">
            <p [ngClass]="{'selectedMenu': this.PriceListMenu == true}" (click)="RedirectToURLWithUrlChange('/B2B/pricelist');">{{'PriceList' | translate}}</p>
          </div> -->
          <!-- <div class="MyCompanyContainer" *ngIf="this.IsAdmin != true;">
            <mat-form-field class="BrandSelectContainer" appearance="outline">
              <mat-label></mat-label>
              <input disabled="true"
                     class="BrandSelect"
                     type="text"
                     matInput
                     [matAutocomplete]="auto1"
                     [(ngModel)]="this.B2BPartnerName"
                     (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                     (click)="InitializePartners();"
                     style="color: #fff;">
              <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.B2BPartner?.Name?.length > 0) != true;">search</i>
              <mat-autocomplete #auto1="matAutocomplete">
                <mat-option *ngFor="let p of Partners" [value]="p" (click)="SelectB2BPartnerForAdmin(p);">
                  {{p.Name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div> -->
          <!-- <div class="MyCompanyContainer" *ngIf="this.IsAdmin == true && this.B2BPartner != null;">
            <mat-form-field class="BrandSelectContainer" appearance="outline">
              <mat-label></mat-label>
              <input class="BrandSelect"
                     type="text"
                     matInput
                     [matAutocomplete]="auto1"
                     [(ngModel)]="this.B2BPartnerName"
                     (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                     (click)="InitializePartners();"
                     [disabled]="IsForcedB2BPartner == true"
                     style="color: #fff;">
              <i class="material-icons BrandSelectCloseIcon" *ngIf="this.B2BPartnerName?.length > 0 && IsForcedB2BPartner != true;" (click)="ClearPartner();">close</i>
              <i class="material-icons BrandSelectCloseIcon" *ngIf="this.B2BPartnerName?.length > 0 && IsForcedB2BPartner == true;" (click)="CancelB2BPartnerForAdminSelection();">close</i>
              <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.B2BPartnerName?.length > 0) != true;">search</i>
              <mat-autocomplete #auto1="matAutocomplete">
                <mat-option *ngFor="let p of Partners" [value]="p" (click)="SelectB2BPartnerForAdmin(p);">
                  {{p.Name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div> -->
          <!-- <mat-slide-toggle *ngIf="this.IsForcedB2BPartner == true;" [(ngModel)]="IsForcedB2BPartner" class="ForcedB2BPartnerSlide" (change)="toggleB2BPartnerForAdminSelection($event)">{{'IsForcedB2BPartner' | translate}}</mat-slide-toggle> -->
        </div>
      </div>

      <div class="SideMenu animated slideInLeft" *ngIf="ShowMainMenu == true">
        <div class="SideMenuUpper">
         <div class="SideMenuButton unSelectable" (click)="RedirectToURLWithUrlChange('B2B/search');">
           <i class="material-icons">storage</i>
           <p>{{'SearchProducts' | translate}}</p>
         </div>

         <div class="SideMenuButton unSelectable" (click)="RedirectToURLWithUrlChange('B2B/my/requests');">
           <i class="material-icons">playlist_add_check</i>
           <p>{{'MyRequestsAndPOLikeRequests' | translate}}</p>
         </div>

         <!-- <div class="SideMenuButton unSelectable">
           <i class="material-icons">verified</i>
           <p>{{'MyOrders' | translate}}</p>
         </div> -->

         <div class="SideMenuButton unSelectable" (click)="RedirectToURLWithUrlChange('/B2B/my/invoices');">
           <i class="material-icons">verified_user</i>
           <p>{{'MyInvoices' | translate}}</p>
         </div>

        </div>

        <div class="SideMenuLower">
         <div class="SideMenuButton unSelectable" (click)="RedirectToURLWithUrlChange('/B2B/profile');">
           <i class="material-icons">account_circle</i>
           <p>{{'MyProfile' | translate}}</p>
         </div>
         <div class="SideMenuButton unSelectable" (click)="showLoggOffContainer = true;">
           <i class="material-icons">logout</i>
           <p>{{'LogOff' | translate}}</p>
         </div>
        </div>

       </div>
      
      <div class="B2BBody">

        <router-outlet></router-outlet>
      </div>

      <div class="FooterContainer">
        <div class="FooterSection">
          <div class="FooterSectionTitle">
            Contact
          </div>
          <div class="FooterSectionBody">
            <p>{{this.Company?.Name}}</p>
            <p>{{this.Company?.VATNumber}}</p>
            <p>{{this.Company?.COCRegisterNr}}</p>
            <p>{{this.Company?.Addresses[0]?.City}} {{this.Company?.Addresses[0]?.ZipCode}}</p>
            <p>{{this.Company?.Addresses[0]?.AddressLine}}</p>
            <p></p>
            <p>{{this.B2BAgent?.Name}}</p>
            <p>{{this.B2BAgent?.Email}}</p>
            <p></p>
            <p>{{this.B2BAgent?.Phone}}</p>
            <p></p>
            <p></p>
            <p></p>
          </div>
        </div>
        <div class="FooterSection">
          <div class="FooterSectionTitle">
            {{'InternalLinks' | translate}}
          </div>
          <div class="FooterSectionBody">
            <p><a style="color: #fff;" href="/B2B/store">{{'SearchProducts' | translate}}</a></p>
            <p></p>
            <p><a style="color: #fff;" href="/B2B/profile">{{'MyProfile' | translate}}</a></p>
            <p></p>
            <p><a style="color: #fff;" href="/B2B/profile">{{'Offers' | translate}}</a></p>
            <p></p>
            <p><a style="color: #fff;" href="/B2B/profile">{{'Orders' | translate}}</a></p>
            <p></p>
            <p><a style="color: #fff;" href="/B2B/profile">{{'MyInvoices' | translate}}</a></p>
          </div>
        </div>
        <div class="FooterSection">
          <div class="FooterSectionTitle">
            {{'PaymentTypes' | translate}}
          </div>
          <div class="FooterSectionBody">
            <p>
              <img src="https://www.foxline.ro/images/maestro-logo.svg">
              <img src="https://www.foxline.ro/images/mastercard-electronic-logo.png">
              <img src="https://www.foxline.ro/images/mastercard-logo.svg">
              <img src="https://www.foxline.ro/images/paypal-logo.svg">
              <img src="https://www.foxline.ro/images/visa-electron-logo.png">
              <img src="https://www.foxline.ro/images/visa-logo.svg">
            </p>
            <p></p>
          </div>
        </div>
        <div class="FooterSection">
          <div class="FooterSectionTitle">
            {{'TransportOptions' | translate}}
          </div>
          <div class="FooterSectionBody">
            <p>
              <img *ngFor="let s of this.ShippingCompanies;let i = index;" [src]="this.BackendServiceUrl + s.ImagePath">
            </p>
          </div>
        </div>
      </div>
  </div>
    